import { Tile } from "./Tile";
import { Image } from "./Image";

export enum ListDisplayType {
  HERO = "hero",
  HERO_PUBLISHER = "heroPublisher",
  FEATURED_LIST = "featuredList",
  FULL = "full",
  FLAT_FEATURED = "flatFeatured",
  FLAT = "flat",
  BANNER = "banner",
  BRANDED = "branded",
  RANDOM = "random",
  FAVORITES = "favorites",
  LAST_PLAYED = "lastPlayed",
  FEATURED = "featured",
  MARKETING = "marketing",
  LEMAG = "lemag",
  BONUS_GAMES = "bonusGames",
}

export interface List {
  uuid: string;
  imgBackground?: Image[];
  imgBanner?: Image[];
  imgMore?: Image[];
  isPaginated: boolean;
  display: ListDisplayType;
  moreTitle?: string;
  moreLink?: string;
  tiles: Tile[];
  total: number;
  title?: string;
  imgLogo?: Image[];
  displayTilesTitle?: boolean;
}
